import { createAsyncThunk } from '@reduxjs/toolkit';
import { PropertyCategory } from '../../../client/services';
import { toastHandler } from '../../../utils/toastHandler';
import {
  CreatePatchPropertyCategory,
  FindPropertyCategory,
  GetPropertyCategory,
} from './interface';

export const findPropertyCategory = createAsyncThunk(
  'propertyCategory/findPropertyCategory',
  async (values: FindPropertyCategory, { rejectWithValue }) => {
    try {
      const response = await PropertyCategory.find({
        query: values,
      });

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const createPropertyCategory = createAsyncThunk(
  'propertyCategory/createPropertyCategory',
  async (values: CreatePatchPropertyCategory, { rejectWithValue }) => {
    try {
      const response = await PropertyCategory.create(values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const patchPropertyCategory = createAsyncThunk(
  'propertyCategory/patchPropertyCategory',
  async (
    { id, ...values }: CreatePatchPropertyCategory,
    { rejectWithValue }
  ) => {
    try {
      const response = await PropertyCategory.patch(id, values);
      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);

export const getPropertyCategory = createAsyncThunk(
  'propertyCategory/getPropertyCategory',
  async ({ id }: GetPropertyCategory, { rejectWithValue }) => {
    try {
      const response = await PropertyCategory.get(id);

      return response;
    } catch (error: any) {
      toastHandler(error);
      return rejectWithValue(error.message);
    }
  }
);
